var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',[_c('span',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.displayCountup))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }